module.exports = __webpack_public_path__ + "static/media/aces_a2_off.b7f25533.svg";